// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@supports not selector(::-webkit-scrollbar) {
  body {
    scrollbar-color: var(--sb-thumb-color) var(--sb-track-color);
  }
}

.input {
  /* width: 300px;
  max-width: 220px; */
  height: 45px;
  padding: 12px;
  border-radius: 12px;
  border: 1.5px solid lightgrey;
  outline: none;
  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  box-shadow: 0px 0px 20px -18px;
}

.input:hover {
  border: 2px solid #0FCFFF;
  box-shadow: 0px 0px 20px -17px;
}

.input:active {
  transform: scale(0.95);
}

.input:focus {
  border: 2px solid #05314B;
}

.btn {
  text-decoration: none;
  margin-top: 8px;
  border: none;
  font-size: 16px;
  font-family: inherit;
  cursor: pointer;
  color: #fff;
  line-height: 2em;
  text-align: center;
  background: #001e72;
  border-radius: 5px;
  z-index: 1;
  transition: 0.3s;
  padding: 6px 59px;
}

.btn:hover {
  border: none;
  background: #0433b3;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

@media (max-width: 576px) {
  p{
    font-size: 14px !important;
  }

  tr{
    font-size: x-small !important;
  }

  td{
    font-size: small !important;
  }

  th{
    font-size: small !important;
  }

  button{
    font-size: small !important;
  }

  a{
    font-size: small !important;
  }

  h1,h2{
    font-size: 16px !important;
  }
  div{
    font-size: small !important;
  }

  th{
    font-size: small !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;qBACmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mDAAmD;EACnD,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAIE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["@supports not selector(::-webkit-scrollbar) {\n  body {\n    scrollbar-color: var(--sb-thumb-color) var(--sb-track-color);\n  }\n}\n\n.input {\n  /* width: 300px;\n  max-width: 220px; */\n  height: 45px;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1.5px solid lightgrey;\n  outline: none;\n  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\n  box-shadow: 0px 0px 20px -18px;\n}\n\n.input:hover {\n  border: 2px solid #0FCFFF;\n  box-shadow: 0px 0px 20px -17px;\n}\n\n.input:active {\n  transform: scale(0.95);\n}\n\n.input:focus {\n  border: 2px solid #05314B;\n}\n\n.btn {\n  text-decoration: none;\n  margin-top: 8px;\n  border: none;\n  font-size: 16px;\n  font-family: inherit;\n  cursor: pointer;\n  color: #fff;\n  line-height: 2em;\n  text-align: center;\n  background: #001e72;\n  border-radius: 5px;\n  z-index: 1;\n  transition: 0.3s;\n  padding: 6px 59px;\n}\n\n.btn:hover {\n  border: none;\n  background: #0433b3;\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\n@media (max-width: 576px) {\n  p{\n    font-size: 14px !important;\n  }\n\n  tr{\n    font-size: x-small !important;\n  }\n\n  td{\n    font-size: small !important;\n  }\n\n  th{\n    font-size: small !important;\n  }\n\n  button{\n    font-size: small !important;\n  }\n\n  a{\n    font-size: small !important;\n  }\n\n  h1,h2{\n    font-size: 16px !important;\n  }\n  div{\n    font-size: small !important;\n  }\n\n  th{\n    font-size: small !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
